import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { unitDetail } from '@/features/unit/api'
import { UnitUpdateForm } from '@/features/unit/components/unit-form'

export const Route = createFileRoute('/_app/inventory/unit/$id')({
	loader: async ({ context, params }) => {
		const { qc } = context
		const { id } = params

		await qc.ensureQueryData(unitDetail.qry({ id }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()
	const { unit } = useSuspenseQuery(unitDetail.qry({ id })).data

	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/unit', 'Konversi Unit'],
					[Route.fullPath, unit.name],
				]}
			/>
			<PageCard>
				<PageCard.Header title="Buat Konversi Unit" />
				<PageCard.Content>
					<UnitUpdateForm />
				</PageCard.Content>
			</PageCard>
		</PageLayout>
	)
}
